const upcomingExhibitions = document.querySelector('.upcoming-exhibitions');

if (upcomingExhibitions) {
  const urlParams = ['locations', 'types', 'audiences', 'pageNumber'];

  const getExtraFormDataInput = (parent, searchInput) => ({
    searchTerm: searchInput || getSearchedData(parent),
    postType: parent.querySelector('[data-post-type]').value,
    locations: getCheckedData(parent, 'locations'),
    types: getCheckedData(parent, 'types'),
    audiences: getCheckedData(parent, 'audiences'),
  });

  // Filter click
  attachEvent('.upcoming-exhibitions .mod-filter .dropdown__list-item input', 'click', (ev) => {
    const parent = ev.target.closest('.upcoming-exhibitions');
    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Pagination
  attachEvent('.upcoming-exhibitions .pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.upcoming-exhibitions');
    axiosGetPaginateAndFilteredPosts(parent, ev.target.dataset.page, urlParams, getExtraFormDataInput(parent));
  });
}
